import reduxFreeFetcher from '@api/fetchers';
import { HOST_TYPE } from '@utils/api-helper/host';

import type {
  FetchTestTabFilteredListParams,
  FetchTestTabFilterMetadataParams,
  FetchTestTabGoalLanguageParams,
  FilteredListResponse,
  GetFilterResponse,
  OngoingResponse
} from './types';

const QUIZ_HOME = 'quiz/v2/home/';

const quizHomeOptions = (overrides: Record<string, unknown> = {}) => ({
  host: HOST_TYPE.BACKEND_API_HOST,
  useAuthToken: false,
  useJWTToken: true,
  useSearchToken: true,
  skipLoader: true,
  ...overrides
});

export const fetchTestTabFilterMetadata = ({
  goalUid,
  apiTabId,
  language = 1,
  limit = 50,
  offset = 0
}: FetchTestTabFilterMetadataParams): Promise<GetFilterResponse> =>
  reduxFreeFetcher(`${QUIZ_HOME}get_filter/`, {
    ...quizHomeOptions(),
    params: {
      goal_uid: goalUid,
      id: apiTabId,
      language,
      limit,
      offset
    }
  }) as Promise<GetFilterResponse>;

export const fetchTestTabFilteredList = ({
  goalUid,
  apiTabId,
  language = 1,
  limit = 50,
  offset = 0,
  order = '',
  filterBody
}: FetchTestTabFilteredListParams): Promise<FilteredListResponse> =>
  reduxFreeFetcher(`${QUIZ_HOME}filter/`, {
    ...quizHomeOptions({ requestType: 'POST' }),
    params: {
      goal_uid: goalUid,
      id: apiTabId,
      language,
      limit,
      offset,
      ...(order ? { order } : {})
    },
    body: filterBody
  }) as Promise<FilteredListResponse>;

export const fetchTestTabOngoing = ({
  goalUid,
  language = 1
}: FetchTestTabGoalLanguageParams): Promise<OngoingResponse> =>
  reduxFreeFetcher(`${QUIZ_HOME}ongoing/`, {
    ...quizHomeOptions(),
    params: {
      goal_uid: goalUid,
      language
    }
  }) as Promise<OngoingResponse>;

export type {
  ApiTabId,
  ApiSubscriptionId,
  ApiTestTypeId,
  FetchTestTabFilteredListParams,
  FetchTestTabFilterMetadataParams,
  FetchTestTabGoalLanguageParams,
  FilteredListResponse,
  GetFilterResponse,
  OngoingResponse,
  QuizCard,
  TestSeriesCard,
  TestTabFilterRequestBody
} from './types';
